import React from 'react';
import * as S from './styled';
import InputCheckbox from '../../InputCheckbox';

export interface InputCheckboxGroupProps {
  options: Array<{ label: string; value: string }>;
  selectedValues: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function InputCheckboxGroup({
  options,
  selectedValues,
  onChange,
  disabled = false,
  loading = false,
  className,
  style,
}: InputCheckboxGroupProps) {
  const handleCheckboxChange = (value: string) => {
    if (loading || disabled) return;

    const updatedSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    onChange(updatedSelectedValues);
  };

  return (
    <S.CheckboxGroupWrapper className={className} style={style}>
      {options.map((option) => (
        <InputCheckbox
          key={option.value}
          label={option.label}
          checked={selectedValues.includes(option.value)}
          onChange={() => handleCheckboxChange(option.value)}
          disabled={disabled}
          loading={loading}
        />
      ))}
    </S.CheckboxGroupWrapper>
  );
}
